import { FC } from "react";

interface Props {
  size: number;
}

const VerifiedIcon: FC<Props> = ({ size }) => (
  <svg
    height={`${size}pt`}
    viewBox="0 -3 430.20321 430"
    width={`${size}pt`}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="m240.898438 88.800781c0 48.988281-39.710938 88.699219-88.699219 88.699219s-88.699219-39.710938-88.699219-88.699219 39.710938-88.699219 88.699219-88.699219 88.699219 39.710938 88.699219 88.699219zm0 0" />
    <path d="m249 269.902344c-27.140625-22.515625-61.335938-34.765625-96.601562-34.601563h-.296876c-41.101562.101563-79.402343 16.101563-107.703124 45.101563-27.199219 28-42.898438 65.699218-44.398438 107l246.300781-.5c-22.542969-36.042969-21.484375-82.039063 2.699219-117zm0 0" />
    <path d="m337.199219 237.402344c-51.363281 0-93 41.636718-93 93 0 51.363281 41.636719 93 93 93s93-41.636719 93-93c.207031-24.730469-9.523438-48.503906-27.011719-65.988282-17.484375-17.488281-41.257812-27.21875-65.988281-27.011718zm44.402343 75.699218-55.902343 45.5c-1.230469 1.035157-2.789063 1.601563-4.398438 1.601563-2.058593.019531-4.011719-.902344-5.300781-2.5l-24.101562-28.101563c-2.511719-2.953124-2.152344-7.386718.800781-9.898437 2.957031-2.515625 7.386719-2.15625 9.902343.796875l19.597657 22.902344 50.601562-41.199219c2.984375-2.429687 7.367188-1.980469 9.800781 1 2.425782 3.019531 1.980469 7.425781-1 9.898437zm0 0" />
  </svg>
);

export default VerifiedIcon;
